
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import {getSwarmDataKeyForRequest, SwarmDataMixin} from "../../../mixins/swarmDataMixin";
import PropTypes from "prop-types";
import {getSwarmSubscriptionRequestHorseRacingCompetitions} from "../../../helpers/terminalRequests/horseRacing";
import {createSelector} from "reselect";

function mouseUpHandler () {
    clearTimeout(this.timerScroll);
    this.clickedSportsList = true;
    this.delta = 0;
    document.removeEventListener("mouseup", mouseUpHandler);
}

let ctx;

class HorseRacingCompetitions extends Component {
    constructor (props) {
        super(props);
        this.state = {

        };
        //this.selectCompetition = this.selectCompetition.bind(this);
        //this.selectDay = this.selectDay.bind(this);
    }

    /**
     * @name selectCompetition
     * @param {string} id
     * @description Select competition by id
     * @return {function}
     * */
    // selectCompetition (id) {
    //     return () => this.setState({ selectedCompetitionId: id, day: undefined });
    // }

    // selectDay (data) {
    //     this.setState({ day: data });
    // }
    static getDerivedStateFromProps (props, state) {
        return {
            selectedCompetitionId: props.params.competitionId
        };
    }
    handleMouseUp () {
        document.addEventListener("mouseup", mouseUpHandler.bind(this));
    }

    // UNSAFE_componentWillReceiveProps (nextProps) {
    //     const {data} = nextProps,
    //         {selectedCompetitionId} = this.state,
    //         firstCompetitionId = data && Object.keys(data.competition)[0];
    //     (firstCompetitionId &&
    //         (!selectedCompetitionId || (selectedCompetitionId !== firstCompetitionId))) &&
    //     this.setState({selectedCompetitionId: firstCompetitionId});
    // }

    scroll (scroller, scrollSize, delay) {
        let iterator = scrollSize > 0 ? 0.1 : -0.1;
        this.delta = this.delta || iterator;
        this.delta += iterator;
        this.clickedSportsList = false;
        scroller.scrollLeft += (scrollSize + this.delta);
        this.timerScroll = setTimeout(() => {
            !this.clickedSportsList && this.scroll(scroller, scrollSize, delay);
        }, delay);
    }

    render () {
        //console.log("________________________________________________________");
        //console.log(this.state);
        //console.log("________________________________________________________");
        ctx = this.props;
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

HorseRacingCompetitions.propTypes = {
    regionId: PropTypes.string,
    data: PropTypes.array,
    loaded: PropTypes.bool
};

const mapStateToProps = (_, ownParams) => {
    const key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestHorseRacingCompetitions(ownParams));
    return createSelector(
        [
            state => state.swarmData.data[key] && JSON.stringify(state.swarmData.data[key]),
            state => state.swarmData.loaded[key]
        ],
        (data, loaded) => {
            let competitionCount, firstCompetitionId, temp;
            if (data) {
                temp = Object.values(JSON.parse(data || '{}').competition).sort((a, b) => a.order - b.order);
                if (temp && temp.length > 0 && loaded) {
                    competitionCount = temp.length;
                    firstCompetitionId = temp[0].id;
                } else if (temp && temp.length === 0) {
                    competitionCount = 0;
                }
            }
            return {
                competitionCount,
                loaded,
                firstCompetitionId,
                selectorKey: key,
                data: temp
            };
        });
};

export default withRouter(connect(mapStateToProps)(SwarmDataMixin({
    Component: HorseRacingCompetitions,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestHorseRacingCompetitions(this.props);
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestHorseRacingCompetitions(this.props));
    },
    ComponentWillReceiveProps: function (nextProps) {
        if (!nextProps.params.competitionId && nextProps.firstCompetitionId) {
            if (ctx && nextProps.location.pathname.indexOf(nextProps.firstCompetitionId) === -1) {
                return ctx.router.replace(nextProps.location.pathname + "/" + nextProps.firstCompetitionId);
            }
        }
    }
})));